(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["launch-fireworks"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const overlay = document.querySelector('[id^="LaunchFireworks-"]');
    if (!overlay) return;

    const forcePreview = new URLSearchParams(window.location.search).get('preview_fireworks') === '1';

    if (!forcePreview && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      overlay.remove();
      return;
    }

    if (!forcePreview) {
      try {
        const seenKey = 'hermoment-launch-fireworks-seen';
        if (sessionStorage.getItem(seenKey)) {
          overlay.remove();
          return;
        }
        sessionStorage.setItem(seenKey, '1');
      } catch (error) {
        overlay.dataset.sessionStorageUnavailable = 'true';
      }
    }

    const canvas = overlay.querySelector('.launch-fireworks__canvas');
    const context = canvas && canvas.getContext('2d');
    if (!context) {
      overlay.remove();
      return;
    }

    let width = 0;
    let height = 0;
    let ratio = 1;
    const particles = [];
    const colors = ['#f7d6a4', '#fff4e8', '#d98a9e', '#f0b7c4', '#ffffff'];

    const resize = () => {
      ratio = Math.min(window.devicePixelRatio || 1, 2);
      width = window.innerWidth;
      height = window.innerHeight;
      canvas.width = Math.round(width * ratio);
      canvas.height = Math.round(height * ratio);
      context.setTransform(ratio, 0, 0, ratio, 0, 0);
    };

    const burst = (centerX, centerY) => {
      for (let index = 0; index < 48; index += 1) {
        const angle = Math.random() * Math.PI * 2;
        const speed = 1.2 + Math.random() * 3.4;
        particles.push({
          x: centerX,
          y: centerY,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed,
          life: 48 + Math.random() * 30,
          radius: 1.4 + Math.random() * 2.2,
          color: colors[Math.floor(Math.random() * colors.length)]
        });
      }
    };

    const startedAt = performance.now();
    const animate = (now) => {
      const elapsed = now - startedAt;
      context.clearRect(0, 0, width, height);

      if (elapsed < 2550 && Math.random() < 0.12) {
        burst(width * (0.12 + Math.random() * 0.76), height * (0.12 + Math.random() * 0.48));
      }

      for (let index = particles.length - 1; index >= 0; index -= 1) {
        const particle = particles[index];
        particle.x += particle.vx;
        particle.y += particle.vy;
        particle.vy += 0.035;
        particle.vx *= 0.991;
        particle.life -= 1;
        context.globalAlpha = Math.min(1, particle.life / 24);
        context.fillStyle = particle.color;
        context.beginPath();
        context.arc(particle.x, particle.y, particle.radius, 0, Math.PI * 2);
        context.fill();

        if (particle.life <= 0) particles.splice(index, 1);
      }

      context.globalAlpha = 1;
      if (elapsed < 3400 && particles.length > 0) requestAnimationFrame(animate);
      else if (elapsed < 3000) requestAnimationFrame(animate);
    };

    resize();
    window.addEventListener('resize', resize, { passive: true });
    requestAnimationFrame(animate);

    window.setTimeout(() => overlay.classList.add('is-fading'), 3000);
    window.setTimeout(() => {
      window.removeEventListener('resize', resize);
      overlay.remove();
    }, 3900);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
